import { useState, useEffect, useRef } from "react";
import Constantes from "../constantes";
import { io } from "socket.io-client";

function ConexionSockets({ amigoId }) {

  const [message, setMessage] = useState(""); // estado para el textarea
  const [messages, setMessages] = useState([]); // lista de mensajes recibidos
  const [socket, setSocket] = useState(null);
  const [offset, setOffset] = useState(0); // para paginación
  const [loading, setLoading] = useState(false); // para evitar cargas simultáneas
  const [hasMore, setHasMore] = useState(true); // para saber si hay más mensajes
  const scrollContainerRef = useRef(null);
  const shouldScrollToBottomRef = useRef(true);

  // Cargar los primeros 50 mensajes
  useEffect(() => {
    const cargarMensajesIniciales = async () => {
      try {
        const res = await fetch(Constantes.RUTA_API + "/mensajes/getMensaje/" + amigoId + "?limit=50&offset=0", {
          method: "GET",
          credentials: "include",
        });
        const data = await res.json();
        const mensajesCargados = Array.isArray(data.message) ? data.message : [];
        setMessages(mensajesCargados);
        setOffset(50);
        console.log("Mensajes obtenidos:", data.message);
        shouldScrollToBottomRef.current = true;
      } catch (err) {
        console.error("Error al cargar mensajes iniciales:", err);
      }
    };

    cargarMensajesIniciales();
  }, [amigoId]);

  // Scroll al final cuando se cargan mensajes inicialmente o llegan nuevos
  useEffect(() => {
    if (scrollContainerRef.current && shouldScrollToBottomRef.current) {
      setTimeout(() => {
        scrollContainerRef.current.scrollTop = scrollContainerRef.current.scrollHeight;
        shouldScrollToBottomRef.current = false;
      }, 0);
    }
  }, [messages]);

  // Socket connection
  useEffect(() => {
    const newSocket = io(Constantes.RUTA_API, {
      autoConnect: true,
      withCredentials: true,
    });
    setSocket(newSocket);

    newSocket.on("connect", () => {
      console.log("Conectado con id:", newSocket.id);
      newSocket.emit("conectar_con_usuario", amigoId);
    });

    newSocket.on("receive_private_message", (data) => {
      console.log("Mensaje recibido:", data);
      setMessages((prev) => [...prev, data]);
      shouldScrollToBottomRef.current = true;
    });

    return () => {
      newSocket.disconnect();
    };
  }, [amigoId]);

  // Detectar scroll hacia arriba y cargar más mensajes
  const handleScroll = async (e) => {
    const container = e.target;
    
    // Si el usuario hace scroll hacia arriba (está cerca del top)
    if (container.scrollTop < 100 && !loading && hasMore) {
      setLoading(true);
      const prevScrollHeight = container.scrollHeight;
      
      try {
        const res = await fetch(
          Constantes.RUTA_API + "/mensajes/getMensaje/" + amigoId + `?limit=50&offset=${offset}`,
          {
            method: "GET",
            credentials: "include",
          }
        );
        const data = await res.json();
        const nuevosMensajes = Array.isArray(data.message) ? data.message : [];
        
        if (nuevosMensajes.length === 0) {
          setHasMore(false);
        } else {
          // Agregar los nuevos mensajes al inicio
          setMessages((prev) => [...nuevosMensajes, ...prev]);
          setOffset((prev) => prev + 50);
          
          // Mantener la posición del scroll relativa
          setTimeout(() => {
            const newScrollHeight = container.scrollHeight;
            container.scrollTop = newScrollHeight - prevScrollHeight;
          }, 0);
        }
      } catch (err) {
        console.error("Error al cargar más mensajes:", err);
      } finally {
        setLoading(false);
      }
    }
  };

  const enviarMensaje = () => {
    if (message.trim() !== "" && socket) {
      socket.emit("send_private_message", { to: amigoId, msg: message });
      setMessage("");
      console.log("Mensaje enviado:", message);
      shouldScrollToBottomRef.current = true;
    }
  };

  return (
    <div style={{ marginTop: "10px" }}>
      <h4 style={{ color: "black" }} >Mensajes:</h4>
      <div 
        ref={scrollContainerRef}
        onScroll={handleScroll}
        style={{ resize: "vertical", background: "#ffffff99", minHeight: "50px", height: "200px", maxHeight: "70vh", overflowY: "auto", padding: "10px", border: "1px solid #ccc", borderRadius: "5px", marginBottom: "10px" }}>

        {loading && <p style={{ color: "black", textAlign: "center" }}>Cargando mensajes anteriores...</p>}
        
        {messages.map((m, i) => (
          m.de === amigoId ?
            <div key={i}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                marginBottom: "8px"
              }}
            >
              <p style={{
                color: "black",
                textAlign: "left",
                maxWidth: "70%",
                padding: "8px 12px",
                borderRadius: "12px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.2)"
              }}>
                {m.mensaje}</p>
            </div> :
            <div key={i}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: "8px"
              }}
            >
              <p style={{
                color: "black",
                textAlign: "left",
                maxWidth: "70%",
                padding: "8px 12px",
                borderRadius: "12px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.2)"
              }}>{m.mensaje}</p>
            </div>
        ))}
      </div>
      <textarea
        value={message}
        style={{height:"120px",resize:"none"}}
        
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Escribe tu mensaje aquí..."
      />
      <button class="mb-2 w-100 rounded" onClick={enviarMensaje}>Enviar</button>

    </div>
  );
}

export default ConexionSockets;